(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.CollegeFundingEvolution",
            {
                url: "/CollegeFundingEvolution",
                component: "collegefundingevolution",
                PageTitle: "College Funding Evolution",
                requiredPermissions: "CollegeFundingEvolution:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("collegefundingevolution",
    {
        templateUrl: "App/Resources/CollegeFundingEvolution/CollegeFundingEvolution.html",
        controller: collegeFundingEvolutionCtrl,
        bindings: {
            states: "<"
        }
    });

    collegeFundingEvolutionCtrl.$inject = ["eligibilityFormDialog", "surveys", "eligibilityFormApi", "purchaseApi", "permissionService", "amplitudeService"];

    function collegeFundingEvolutionCtrl(eligibilityFormDialog, surveys, eligibilityFormApi, purchaseApi, permissionService, amplitudeService) {

        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        //TODO: remove and replace from DB
        $ctrl.CFEAccess = { HasAccess: true };

        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.collegeFundingEvolutionId).then(function (response) {
                $ctrl.submitted = response;
            });
        });       

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.collegeFundingEvolutionId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }
       
        $ctrl.activateCFESso = function () {

            //TODO: change this to real sso if it ever becomes one, just open link to their login page for now.
            if (permissionService.hasOnePermission("CollegeFundingEvolution:Access")) {
                var w = window.open("https://collegefundingevolution.mykajabi.com/login");
            }
        }
    }  
})(window.app, window.angular); // jshint ignore:line